import React from "react";
import TierCard from "./TierCard";
import Pinnacle from "./Pinnacle";

export default function Roadmap({
  tiers = [],
  pinnacle = null,
  completedLevelsCount = 0,
}) {
  const currentLevel = completedLevelsCount + 1;

  return (
    <div className="card border-0 shadow-sm rounded-4" id="roadmap-section">
      <div className="card-body p-3 p-md-4">
        <h5 className="fw-bold mb-1">
          <i className="bi bi-trophy marketing_level_text_gold me-2" />
          10-Tier Roadmap Journey
        </h5>

        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
          <p className="small marketing_level_text_muted mb-0">
            Detailed progression milestones across all 10 operational ranks from Bronze Starter to Star Elite.
          </p>
          <div className="d-flex flex-wrap gap-2">
            <span className="badge marketing_level_bg_green rounded-pill">
              {completedLevelsCount > 0
                ? `Completed (Tier ${completedLevelsCount >= 1 ? "1" : ""}${
                    completedLevelsCount > 1 ? `–${completedLevelsCount}` : ""
                  })`
                : "Tier 1 In Progress"}
            </span>
            <span className="badge marketing_level_bg_blue rounded-pill">
              Current Standing (Tier {Math.min(10, currentLevel)})
            </span>
            <span className="badge marketing_level_bg_gray rounded-pill">
              Locked Tiers ({Math.min(10, currentLevel + 1)}–10)
            </span>
          </div>
        </div>

        <div className="marketing_level_tier_grid">
          {tiers.map((t) => (
            <TierCard key={t.id} t={t} />
          ))}
        </div>

        <Pinnacle pinnacle={pinnacle} />
      </div>
    </div>
  );
}

